"use client"
import dynamic from "next/dynamic";
import BackgroundSection from "@/components/BackgroundSection";
import BgGlassmorphism from "@/components/BgGlassmorphism";
import SectionGridAuthorBox from "@/components/SectionGridAuthorBox";
import SectionSliderNewCategories from "@/components/SectionSliderNewCategories";
import React, { ReactNode, useEffect, useState } from "react";

// Newsletter is far below the fold — defer its JS so it doesn't compete
// with the tour grid for the LCP window. min-height reserved on its
// placeholder keeps the page CLS-stable.
const SectionSubscribe2 = dynamic(
  () => import("@/components/SectionSubscribe2"),
  {
    ssr: false,
    loading: () => <div style={{ minHeight: 280 }} aria-hidden="true" />,
  }
);
//import SectionHeroArchivePage from "../../(server-components)/SectionHeroArchivePage";
import SectionHeroTours from "../../(server-components)/SectionHeroTours";
import { useAppSelector, useAppDispatch } from '@/app/lib/hooks';
import { getCities } from '@/app/lib/reducers/citiesReducer';

import { useSearchParams } from 'next/navigation';

const Layout = ({ children }: { children: ReactNode }) => {
  const dispatch = useAppDispatch();
  const cities = useAppSelector(state => state.cities.cities);
  const selectedLanguage = useAppSelector(state => state.language.selectedLanguage || "en_US");
  const selectedCategories = useAppSelector(state => state.tours.filters.categories);
  const tours = useAppSelector(state => state.tours);
  const searchParams = useSearchParams();
  const [page, setPage] = useState(parseInt(searchParams.get('page') || '1', 10));
  const filters = useAppSelector(state => state.tours.filters);

  useEffect(() => {
    dispatch(getCities());
  }, [dispatch, selectedLanguage]);


  return (
    <div className={`nc-ListingStayPage relative `}>
      <BgGlassmorphism />

      {/* SECTION HERO */}
      <div className="container pt-0 pb-1 lg:pt-0 lg:pb-4"> {/*pt-10 pb-24 lg:pt-16 lg:pb-28*/}
        {/*<SectionHeroTours
          currentPage="Private"
          currentTab="Private"
          listingType={
            <>
              <i className="text-2xl las la-umbrella-beach"></i>
              <span className="ml-2.5">{cities.length} Destinations</span>
            </>
          }
        />*/}
      </div>

      {children}

      <div className="container overflow-hidden">
        {/* SECTION 1 
        <div className="relative py-16">
          <BackgroundSection />
          <SectionSliderNewCategories
            heading="Explore by types of stays"
            subHeading="Explore houses based on 10 types of stays"
            categoryCardType="card5"
            itemPerRow={5}
            sliderStyle="style2"
          />
        </div>*/}

        {/* SECTION */}
        <SectionSubscribe2 className="py-24 lg:py-28" />

        {/* SECTION 
        <div className="relative py-16 mb-24 lg:mb-28">
          <BackgroundSection className="bg-orange-50 dark:bg-black dark:bg-opacity-20 " />
          <SectionGridAuthorBox />
        </div>*/}
      </div>
    </div>
  );
};

export default Layout;
